import { makeStyles } from '@material-ui/core';

export const useSectionProfileStyles = makeStyles((theme) => ({
  tileRoot: {
    display: 'flex',
    // justifyContent: 'center',
    flexWrap: 'wrap',
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: '100%',
    [theme.breakpoints.up('sm')]: {
      minWidth: '40%',
      margin: '1%',
      maxWidth: '50%',
    },
  },
  tileFooter: {
    marginTop: 'auto',
  },
}));
